import * as React from "react";
import styled from "styled-components";

import Select from "@8x8/oxygen-select";
import Input from "@8x8/oxygen-input";
import SearchIcon from "@8x8/oxygen-icon/novo/SearchIcon";

import { CustomerSearchFields } from "@/react/features/customer/searchCustomer";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const TypeColumn = styled.div`
  flex: 1;
  margin-right: 4px;
`;

const TermColumn = styled.div`
  flex: 2;
  margin-right: 4px;
`;

const SEARCH_TERM_OPTIONS = Object.freeze([
  {
    value: CustomerSearchFields.NAME,
    label: "Customer Name",
  },
  {
    value: CustomerSearchFields.ID,
    label: "Customer ID",
  },
  {
    value: CustomerSearchFields.TENANT_NAME,
    label: "Tenant Name",
  },
  {
    value: CustomerSearchFields.PBX_NAME,
    label: "PBX Name",
  },
]);

const ENTER_KEYCODE = 13;

const SearchControls = ({ onSearch, menuPortalTarget }) => {
  const [selectedField, setSelectedField] = React.useState(
    SEARCH_TERM_OPTIONS[0]
  );
  const [term, setTerm] = React.useState("");
  const onKeyChange = React.useCallback(
    (option) => setSelectedField(option),
    [setSelectedField]
  );
  const onKeyDown = (event) => {
    if (event.keyCode === ENTER_KEYCODE && term?.length > 0) {
      onSearch({ field: selectedField.value, term });
    }
  };

  return (
    <Container>
      <TypeColumn>
        <Select
          onChange={onKeyChange}
          options={SEARCH_TERM_OPTIONS}
          value={selectedField}
          isClearable={false}
          menuPortalTarget={menuPortalTarget}
        />
      </TypeColumn>
      <TermColumn>
        <Input
          iconLeft={() => <SearchIcon />}
          type="text"
          onChange={(e) => setTerm(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={"press Enter to submit query"}
        />
      </TermColumn>
    </Container>
  );
};

export default SearchControls;
